import { type LinkComponent, createLink } from "@tanstack/react-router";
import { forwardRef } from "react";

type Direction = "forward" | "back" | "none";

interface AppAnchorProps extends Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, "children"> {
  direction?: Direction;
}

const AppAnchor = forwardRef<HTMLAnchorElement, AppAnchorProps>(({ direction: _direction, ...props }, ref) => {
  return <a ref={ref} {...props} />;
});

const CreatedLink = createLink(AppAnchor);

export const AppLink: LinkComponent<typeof AppAnchor> = (rawProps) => {
  const direction = rawProps.direction ?? "forward";
  const preload = rawProps.preload ?? "intent";
  const viewTransition = rawProps.viewTransition ?? (direction === "none" ? false : { types: [direction] });

  const props = { ...rawProps, preload, viewTransition } as typeof rawProps;

  return <CreatedLink {...props} />;
};
